import { getActiveTrace } from './getActiveTrace';
import { makeTraceHttpHeaders } from './utils';

/**
 * Gets the active trace context as B3 HTTP request headers.
 * Returns null if no trace context is currently active.
 *
 * @returns An object with HTTP headers to add to outgoing requests in order to propagate the trace context,
 * or null if no active trace.
 *
 * @example
 * ```typescript
 * const traceHeaders = getActiveTraceHttpHeaders();
 * if (traceHeaders) {
 *   fetch('/api/endpoint', {
 *     headers: {
 *       ...existingHeaders,
 *       ...traceHeaders,
 *     }
 *   });
 * }
 * ```
 */
export function getActiveTraceHttpHeaders(): Record<string, string> | null {
	const trace = getActiveTrace();
	if (!trace) {
		return null;
	}

	const { traceId, spanId } = trace;
	return makeTraceHttpHeaders(traceId, spanId);
}
